import { Link } from 'react-router-dom';
import { worksList } from '@/mocks/works';

export default function PopularWorks() {
  const items = worksList.slice(0, 4);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-5">
        <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">热门影视作品</h3>
        <Link to="/works" className="cursor-pointer whitespace-nowrap text-sm text-primary-700 hover:text-accent-600 flex items-center gap-1">
          查看更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
        {items.map((work) => (
          <Link key={work.id} to={`/detail/${work.id}`} className="cursor-pointer group">
            <div className="w-full aspect-[3/4] rounded-md overflow-hidden mb-2">
              <img src={work.cover} alt={work.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
            </div>
            <p className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 truncate">{work.title}</p>
            <div className="flex items-center justify-between mt-1">
              <span className="text-xs text-foreground-500 whitespace-nowrap">{work.year} · {work.type}</span>
              <span className="text-xs text-accent-600 font-semibold flex items-center gap-0.5">
                <i className="ri-star-fill text-[10px]"></i>
                {work.rating}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}